export class User{
    creationDate?: number;
    defaultMillId?:number;
    defaultOfficeId?:number;
    groupsId?: number[];
    isDefaultOfficeEditable?: boolean;
    lastLogin?: number;
    lastUpdate?: number;
    username?: string;
    sapEmployeeNumber?: string;
    isSapEmployeeNumberEditable?: boolean;
}

export class UserForGrid{
    creationDate?: number;
    mill?: string;
    officeCode?:string;
    groupCode?: string;
    isDefaultOfficeEditable?: boolean;
    lastLogin?: number;
    lastUpdate?: number;
    username?: string;
}

export class UserToSave{
    username?: string;
    officeId?: number | null;
    millId?: number | null;
    groupsId?: number[];
    sapEmployeeNumber?: string | null;
}

export class Users{
    users?: User[];
}